import { cn } from '@/lib/utils'
import { StageGlyph } from '@/components/app/indicators/StageGlyph'
import { useStatusStage } from '@/routes/features/tasks/hooks/useStatusStage'

interface StatusIconProps {
  progressType: string
  /** Pass it where known: in-progress statuses need it to tell "active" from "review". */
  statusId?: string | null
  size?: 'sm' | 'md'
  className?: string
}

/** A status's stage glyph (design 31a) — the one status shape across the app. */
export function StatusIcon({ progressType, statusId, size = 'md', className }: StatusIconProps) {
  const stage = useStatusStage(statusId, progressType)
  return <StageGlyph stage={stage} className={cn(size === 'sm' && 'size-3', className)} />
}
